module.exports = __webpack_public_path__ + "static/img/big-img-new.08f781c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCodePhone/big-img-new.png
// module id = EYkH
// module chunks = 0